<template>
  <section class="fc-introduce">
    <h4 class="fc-introduce__title">수강 대상</h4>
    <h6 class="fc-introduce__sub-title">이런 분들께 추천 드려요!</h6>
    <ul class="fc-introduce__cards">
      <li v-for="{ icon, title } in cards" :key="title" class="fc-introduce__card">
        <figure class="fc-introduce__icon">
          <img :src="icon" :alt="title" />
        </figure>
        <span class="fc-introduce__desc">{{ title }}</span>
      </li>
    </ul>
    <h4 class="fc-introduce__title">학습 목표</h4>
    <h6 class="fc-introduce__sub-title">이 강의에서는 이런 것들을 얻을 수 있습니다.</h6>
    <ul class="fc-introduce__wrapper">
      <li v-for="(desc, i) in descriptions" :key="i" class="fc-introduce__text" v-html="desc"></li>
    </ul>
  </section>
</template>

<script>
import Introduce01 from '../../../../img/ab-test/introduce_01.png';
import Introduce02 from '../../../../img/ab-test/introduce_02.png';
import Introduce03 from '../../../../img/ab-test/introduce_03.png';
import Introduce04 from '../../../../img/ab-test/introduce_04.png';

export default {
  name: 'introduce-data',
  data() {
    return {
      Introduce01,
      Introduce02,
      Introduce03,
      Introduce04,
      cards: [
        {
          icon: Introduce01,
          title: '데이터를 바탕으로 계량적인 투자를 하고싶어하는 개인투자자',
        },
        {
          icon: Introduce02,
          title: '금융권 커리어를 준비하는 학생',
        },
        {
          icon: Introduce03,
          title: '금융권 내 비퀀트 업무 종사자',
        },
        {
          icon: Introduce04,
          title: '금융권으로 이직을 준비하는 직장인 IT 종사자',
        },
      ],
      descriptions: [
        '✔️   R을 이용해 주식 투자에 필요한 각종 데이터를 크롤링하고 정리할 수 있게 됩니다.',
        '✔️   퀀트 모델을 통해 포트폴리오를 구성하고, 백테스트 및 성과를 평가할 수 있게 됩니다.',
        '✔️   퀀트 모델에 대한 이해를 높이고, 코드를 통해 실제 구현을 할 수 있게 됩니다.',
        '✔️   웹페이지를 통한 지속적인 업데이트 및 전체 소스를 제공합니다.',
      ],
    };
  },
};
</script>
